import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './SelectInputWithSymbol.scss';

function SelectInputWithSymbol({
  label,
  symbol,
  symbolPosition,
  inputName,
  value,
  onChange,
  options,
  containerWidth,
  children,
}) {
  return (
    <div className="select-with-symbol" style={{ width: containerWidth }}>
      {label}
      <div className="select-container">
        {symbolPosition === 'left' && (
        <span className="symbol">
          {typeof symbol === 'string' ? symbol : symbol}
        </span>
        )}
        <Select
          id={inputName}
          className="basic-single"
          classNamePrefix="select"
          name={inputName}
          value={value}
          onChange={(event) => onChange(event)}
          options={options}
        />
        {symbolPosition === 'right' && (
        <span className="symbol">
          {typeof symbol === 'string' ? symbol : symbol}
        </span>
        )}
      </div>
      {children && <div className="extra-content">{children}</div>}
    </div>
  );
}

SelectInputWithSymbol.propTypes = {
  label: PropTypes.string,
  symbol: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  symbolPosition: PropTypes.oneOf(['left', 'right']),
  inputName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    }),
  ), // Options for select input
  containerWidth: PropTypes.string,
  children: PropTypes.node, // For nested content
  errors: PropTypes.shape({}),
};

SelectInputWithSymbol.defaultProps = {
  label: null,
  symbol: '$',
  symbolPosition: null,
  errors: {},
  containerWidth: '100%',
  options: [],
  children: null,
};

export default SelectInputWithSymbol;
